'use client';

import React, { useCallback } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';

/**
 * Replica el módulo legacy `/revisionDocumental`:
 * - estatus = "ENTREGA A RIESGOS"
 * - fechaPrimerSolicitudVoBo == "" (sin VoBo)
 * - fechaRevisionDocumentalConluida vacío o inexistente (no completadas)
 * - Filtra por analista si el usuario es analista de riesgos
 * 
 * Usa el endpoint específico GET /solicitudes/revision-documental?owner_id={ownerID}
 * que filtra en el backend según las reglas del legacy.
 */
const RevisionDocumentalManagement: React.FC = () => {
  const customFetch = useCallback(async (setSolicitudes: (s: Solicitud[]) => void) => {
    // Obtener ownerID del usuario actual
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      throw new Error('No se pudo identificar al usuario. Por favor, inicia sesión nuevamente.');
    }

    // Usar el endpoint específico de revisión documental
    const response = await solicitudService.getRevisionDocumental(String(currentUser.ownerID));
    
    if (response.data) {
      setSolicitudes(response.data);
    } else {
      throw new Error(response.error || 'Error al cargar las solicitudes');
    }
  }, []);

  const extraFilter = useCallback((s: Solicitud) => {
    // Filtro adicional por si acaso (aunque el backend ya filtra)
    const vobo = (s.fechaPrimerSolicitudVoBo || '').trim();
    const rev = (s.fechaRevisionDocumentalConluida || '').trim();
    return vobo === '' && rev === '';
  }, []);

  return (
    <SolicitudManagement
      fixedStatus="ENTREGA A RIESGOS"
      title="Revisión Documental"
      extraFilter={extraFilter}
      modulo="revision-documental"
      customFetch={customFetch}
      showNewButton={false}
    />
  );
};

export default RevisionDocumentalManagement;

